import { Person } from '@local/common-lib';
import * as Sentry from '@sentry/react';
import type { AxiosError } from 'axios';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import type { Issue } from 'validata';
import { useFetchAllCache } from '../../hooks/use-cache.js';
import { useAuthenticated } from '../../utils/auth/index.js';
import { formikCheck, issuesToFormik } from '../../utils/validation.js';
import { EditView } from './edit.view.js';

export const CreatePersonPage: FC = () => {
  const auth = useAuthenticated();
  const navigate = useNavigate();
  const cache = useFetchAllCache('person');
  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik<Person.Create>({
    initialValues: {
      email: '',
      firstName: '',
      lastName: '',
      phone: '',
      roles: [],
    },
    onSubmit: (values) => {
      return (
        auth.axios
          .post<{ inserted: Person.View }>('/api/v1/person', values)
          // auth.axios.patch<{ updated: Person.View }>(`/api/v1/person/${encodeURIComponent(id)}`, values)
          .then(() => {
            cache.invalidate();
            navigate(-1);
            enqueueSnackbar('Created', { variant: 'success' });
            return undefined;
          })
          .catch(
            (
              error: AxiosError<{
                error?: { message: string };
                issues: Issue[];
              }>,
            ) => {
              if (error.response?.status === 409) {
                formik.setErrors({
                  email:
                    error.response.data.error?.message ??
                    'A person with this email address already exists',
                });
                return;
              }
              console.log(error);
              Sentry.captureException(error);
              if (error.response && error.response.status === 400) {
                if (error.response.data && 'issues' in error.response.data) {
                  const issues = error.response.data.issues;
                  formik.setErrors(issuesToFormik(issues));
                  return;
                }
              }
              // TODO setData(error);
            },
          )
      );
    },
    validate: (value) => formikCheck(Person.createContract, value),
  });

  return <EditView cancel={() => navigate(-1)} formik={formik} />;

  // const [loading, setLoading] = useState(false);
  // const [data, setData] = useState<PersonData | Error | undefined>({ email: '', firstName: '', lastName: '', phone: '', roles: [] });
  // const [issues, setIssues] = useState<Map<string, Issue[]>>(new Map<string, Issue[]>());
  // useSetTitle('Create a New Person');

  // const save = useCallback(() => {
  //   setLoading(true);
  //   auth.axios.post<{ inserted: Person.View }>('/api/v1/person', data)
  //     .then((result) => {
  //       setLoading(false);
  //       cache.invalidate();
  //       history.goBack();
  //       enqueueSnackbar('Created', { variant: 'success' });
  //     })
  //     .catch((error: AxiosError<{ issues: Issue[] }>) => {
  //       console.log(error);
  //       setLoading(false);
  //       if (error.response && error.response.status === 400) {
  //         if ('issues' in error.response.data) {
  //           const issues = error.response.data.issues;
  //           const indexed = issues.reduce((acc, issue) => {
  //             const path = issue.path.map((part) => String(part)).join('.');
  //             const array = acc.get(path) || [];
  //             array.push(issue);
  //             return acc.set(path, array);
  //           }, new Map<string, Issue[]>());
  //           setIssues(indexed);
  //           return;
  //         }
  //       }
  //       setData(error);
  //     });
  // }, [data]);

  // if (data === undefined || loading) return <MiddleSpinner />;

  // if (data instanceof Error) return <ErrorPage error={data} />;

  // const patchData = <K extends keyof PersonData, V extends PersonData[K]>(key: K, value: V): void => {
  //   setData({
  //     ...data,
  //     [key]: value,
  //   });
  // };

  // return <View
  //   cancel={() => history.goBack()}
  //   data={data}
  //   issues={issues}
  //   patchData={patchData}
  //   save={save}
  // />;
};
